var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrows = function SvgArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.333 13.333 23.667 10l-3.334-3.333M11.667 6.667 8.333 10l3.334 3.334",
    stroke: "#1F2D27"
  })));
};

export { SvgArrows as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAzMiAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjMzMzMgMTMuMzMzMkwyMy42NjY2IDkuOTk5ODRMMjAuMzMzMyA2LjY2NjUiIHN0cm9rZT0iIzFGMkQyNyIgc3Ryb2tlTGluZWNhcD0icm91bmQiIHN0cm9rZUxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTEuNjY2NyA2LjY2NjgzTDguMzMzMzcgMTAuMDAwMkwxMS42NjY3IDEzLjMzMzUiIHN0cm9rZT0iIzFGMkQyNyIgc3Ryb2tlTGluZWNhcD0icm91bmQiIHN0cm9rZUxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";